import { STORE_FOOD_COURTS_LIST } from "../actions";

export default function storeFoodCourtsList(payload) {
  return {
    type: STORE_FOOD_COURTS_LIST,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/foodCourtsList.js